module.exports = __webpack_public_path__ + "static/media/  (38).c41c8bd4.jpg";